import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 font-body font-medium tracking-wide text-sm uppercase transition-colors duration-300 select-none";

export const CTAButton = ({ to, href, children, variant = "primary", className = "", testId, onClick }) => {
  const styles =
    variant === "primary"
      ? "bg-[#e60000] text-white px-7 py-3.5 hover:bg-[#990000]"
      : variant === "ghost"
      ? "border border-white/40 text-white px-7 py-3.5 hover:bg-white hover:text-black"
      : "text-white px-0 py-1";
  const cls = `${base} ${styles} ${className}`;
  const content = (
    <>
      {children}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </>
  );
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testId} onClick={onClick}>
        {content}
      </Link>
    );
  if (href)
    return (
      <a href={href} className={cls} data-testid={testId} onClick={onClick}>
        {content}
      </a>
    );
  return (
    <button className={cls} data-testid={testId} onClick={onClick}>
      {content}
    </button>
  );
};

export default CTAButton;
